<template>
  <div class="_content">
    <div class="content">
      <p class="title">小鲲车服合作商户结算流程说明</p>
      <!-- <p class="t-child">
        非常重要，请务必仔细阅读！如有疑问可联系您的商户专员
      </p> -->
      <p class="name">&nbsp;&nbsp;&nbsp;&nbsp;尊敬的小鲲车服合作商户：</p>
      <p class="text">
        &nbsp;&nbsp;&nbsp;&nbsp;你们好！感谢大家一直以来对小鲲车服的支持。为让大家更清楚的知晓小鲲车服的结算流程，现做如下说明：
        <br />&nbsp;&nbsp;&nbsp;&nbsp;1、商户工作人员在小鲲车服商户端（关注“小鲲车服”公众号，点击底部菜单“商户平台”
        进入）点击【结算管理】进入自助申请出账结算，商户端会按照年度和月度对全部订单的出
        账情况进行统计展示，方便商户自助查看出账及打款情况；
        <br />&nbsp;&nbsp;&nbsp;&nbsp;2、可进行【结算管理】操作的商户工作人员，商户端账号需为“店长”或“老板”类型，“员
        工”类型账号无法进行结算相关操作；
        <br />&nbsp;&nbsp;&nbsp;&nbsp;3、每个商户每月可申请1次出账，建议在月末申请，每次可将未出账的订单按照月份
        选择全部一次性申请出账结算。出账成功后会生成一笔结算账单，可点击页面【结算明细】
        查看结算账单的状态，出账时请务必确认结算账户信息准确无误，否则将会影响打款进度；
        <br />&nbsp;&nbsp;&nbsp;&nbsp;4、小鲲车服工作人员会在每月10日之前完成上月所有商户申请的全部对结算账单的
        审核工作，如有出现审核不通过的情况，工作人员会与您联系进行核实；
        <br />&nbsp;&nbsp;&nbsp;&nbsp;5、小鲲车服财务人员会在每月11日之前完成所有商户已审核通过结算账单的打款工
        作，打款结果（成功或失败）将会通过微信消息、短信等方式通知到您。对于打款失败的，
        工作人员会与您联系核实打款账户信息。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;再次感谢各位商户的配合与支持，祝您生意兴隆！
      </p>
      <p class="end">小鲲科技商户管理部<br />2023年04月18日</p>
    </div>
  </div>
</template>

<script>
import config from "@/configs/config";
export default {
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style lang="less" scoped>
._content {
  width: 100%;
  height: 100%;
  background: #fff;
}
.content {
  height: 100%;
  padding: 0 0.3rem;
  .title {
    font-size: 0.75rem;
    color: #333;
    font-weight: 600;
    text-align: center;
    padding: 1.5rem 0 1rem;
  }
  .t-child {
    font-size: 0.6rem;
    color: red;
    text-align: center;
    margin-bottom: 0.5rem;
  }
  .name {
    font-size: 0.65rem;
    color: #333;
    line-height: 1.5rem;
  }
  .text {
    color: #333;
    font-size: 0.65rem;
    line-height: 1rem;
    padding: 0 0.75rem;
    line-height: 1.2rem;
    span {
      color: red;
    }
  }
  .end {
    padding: 0.75rem;
    line-height: 1rem;
    text-align: right;
    font-size: 0.7rem;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/text.vue